import { skipToken } from "@reduxjs/toolkit/query/react";
import {
  useGetCollabUsersQuery,
  useGetCustomUsersQuery,
  useGetTeamUsersQuery,
} from "@services/user";
import type { ContactItem } from "@survey-types/survey.contacts.types";

/**
 * Hook to fetch and combine all available contacts from different sources
 */
export const useAvailableContacts = (teamId?: string, projectId?: string) => {
  const { data: teamUsers = [] } = useGetTeamUsersQuery(
    teamId ? { teamId } : skipToken,
  );

  const { data: customUsers = [] } = useGetCustomUsersQuery(
    teamId ? { teamId } : skipToken,
  );

  const { data: collabUsers = [] } = useGetCollabUsersQuery(
    projectId ? { projectId } : skipToken,
  );

  const allContacts: ContactItem[] = [
    ...teamUsers,
    ...customUsers,
    ...collabUsers,
  ].map((item) => ({
    name: item.name ?? "",
    email: item.email ?? "",
    title: item.title ?? "",
    phone: item.phoneNumber ?? "",
  }));

  return {
    allContacts,
    teamUsers,
    customUsers,
    collabUsers,
  };
};
